import React from 'react';
import './DataNotFound.scss';

const DataNotFound = () => {
  return <div className="no-data">Data not valid or not found</div>;
};

export default DataNotFound;
